import {gql} from 'apollo-boost'

export const GET_EVENTLOGS = gql`
  query getEventLogs {
    getEventLogs {
      id
      ipAddress
      logLevel
      method
      message
      errorCode
      account{
        id
        prefix{
          id
          nameTh
        }
        name
        surname
        email
      }
      payload
      createdAt
    }
  }
`

export const GET_LOGINLOGS = gql`
  query getLoginLogs {
    getLoginLogs{
      id
      loginDate
      expireDate
      token
      type
      account{
        id
        prefix{
          id
          nameTh
        }
        name
        surname
        email
      }
      status
      createdAt
    }
  }
`

export const GET_TRANSACTIONLOGS = gql`
  query getTransactionLogs {
    getTransactionLogs{
      id
      action
      method
      type
      account{
        id
        prefix{
          id
          nameTh
        }
        name
        surname
        email
      }
      payload
      createdAt
    }
  }
`

export const GET_IMPORTLOGS = gql`
  query getImportLogs {
    getImportLogs{
      id
      importCode
      importType
      fileName
      meta
      payload
      row
      success
      error
      remark
      status
      account{
        id
        prefix{
          id
          nameTh
        }
        name
        surname
        email
      }
      createdAt
    }
  }
`

export const DELETE_IMPORTLOG = gql`
  mutation deleteImportLog($id: ID!) {
    deleteImportLog(
      id: $id
    ) {
      id
    }
  }
`

export const GET_MENUS = gql`
  query getMenus {
    getMenus{
      id
      icon
      name
      i18n
      sequence
      url: route
      submenu: subMenus{
        id
        name
        i18n
        sequence
        url: route
        slug
        status
      }
      status
    }
  }
`

export const GET_SUB_MENUS_BY_MENU_ID = gql`
  query getSubMenusByMenuID($id: ID!) {
    getSubMenusByMenuID(
      id: $id
    ) {
      id
      name
      i18n
      sequence
      url: route
      slug
      status
      menu{
        id
        icon
        name
        i18n
        sequence
        url: route
        status
      }
    }
  }
`

export const GET_SUB_MENUS = gql`
  query getSubMenus {
    getSubMenus {
      id
      name
      i18n
      sequence
      url: route
      slug
      status
      menu{
        id
        icon
        name
        i18n
        sequence
        url: route
        status
      }
    }
  }
`

export const GET_ROLE = gql`
  query getRole($id: ID!) {
    getRole(
      id: $id
    ){
      id
      nameTh
      nameEn
      status
      type
      permissions{
        id
        subMenu{
          id
        }
        visible
        create
        edit
        delete
      }
    }
  }
`

export const GET_ROLES = gql`
  query getRoles {
    getRoles{
      id
      nameTh
      nameEn
      status
      type
      permissions{
        id
        subMenu{
          id
        }
        visible
        create
        edit
        delete
      }
    }
  }
`

export const CREATE_ROLE = gql`
  mutation createRole($payload: RoleInput!) {
    createRole(
      payload: $payload
    ){
      id
      nameTh
      nameEn
      status
      type
    }
  }
`

export const UPDATE_ROLE = gql`
  mutation updateRole($id: ID!, $payload: RoleInput!) {
    updateRole(
      id: $id
      payload: $payload
    ){
      id
      nameTh
      nameEn
      status
      type
    }
  }
`

export const DELETE_ROLE = gql`
  mutation deleteRole($id: ID!) {
    deleteRole(
      id: $id
    ) {
      id
      nameTh
      nameEn
      status
      type
    }
  }
`

export const GET_CONTRACT_AGING_NINETY_DAY = gql`
  query getContractAgingNinetyDay{
    getContractAgingNinetyDay{
      id
      contractNo
      contractName
    }
  }
`

export const GET_CONTRACT_NEXT_ROUND_NULL = gql`
  query getContractNextRoundNull{
    getContractNextRoundNull{
      id
      contractNo
      contractName
    }
  }
`

export const GET_CONTRACT_TRANSACTION_NOT_UPDATE = gql`
  query getContractTransactionNotUpdate{
    getContractTransactionNotUpdate{
      id
      contractNo
      contractName
    }
  }
`

export const GET_CONTRACT_NEXT_ROUND_FIRST_PRINCIPLE_PERIOD = gql`
  query getContractNextRoundFirstPrinciplePeriod{
    getContractNextRoundFirstPrinciplePeriod{
      id
      contractNo
      contractName
    }
  }
`

export const GET_CONTRACT_REPEAT_PAYMENTS = gql`
  query getContractRepeatPayments{
    getContractRepeatPayments{
      id
      contractNo
      contractName
    }
  }
`

export const GET_CONTRACT_TO_BE_FEE = gql`
  query getContractToBeFee{
    getContractToBeFee{
      id
      contractNo
      contractName
    }
  }
`

export const DAILY_CALCULATORS = gql`
  mutation dailyCalculators{
    dailyCalculators{
      id
      contractNo
      contractName
    }
  }
`

export const DAILY_CREATE_USER_STUDENT = gql`
  mutation dailyCreateUserStudent{
    dailyCreateUserStudent{
      id
      name
      surname
    }
  }
`

export const MONTHLY_EIR_CALCULATORS = gql`
  mutation monthlyEirCalculators{
    monthlyEirCalculators{
      id
      contractNo
      contractName
    }
  }
`

export const GET_MAINTENANCES = gql`
  query getMaintenances{
    getMaintenances{
      id
      maintenanceSystem
      start
      end
      status
    }
  }
`

export const UPDATE_MAINTENANCES = gql`
  mutation updateMaintenances($payload: [MaintenanceInput]) {
    updateMaintenances(
      payload: $payload
    ){
      id
      maintenanceSystem
      start
      end
      status
    }
  }
`

export const GET_CONFIG = gql`
  query config {
    config{
      companyName
      companyNameEn
      companyPhone
      companyLine
      companyLineId
      companyEmail
      otpEmail
    }
  }
`

export const GET_CONFIG_SIGNER = gql`
  query configSigner {
    configSigner{
      signerDetails{
        id
        signerId
        name
        type
        description
      }
    }
  }
`

export const UPDATE_CONFIG = gql`
  mutation updateConfig($payload: ConfigInput!) {
    updateConfig(
      payload: $payload
    ){
      companyName
      companyNameEn
      companyPhone
      companyLine
      companyLineId
      companyEmail
    }
  }
`

export const UPDATE_CONFIG_SIGNER = gql`
  mutation updateConfigSigner($payload: ConfigSignerInput!) {
    updateConfigSigner(
      payload: $payload
    ){
      signerDetails{
        id
        signerId
        name
        type
        description
      }
    }
  }
`

export const SEND_OTP_EMAIL = gql`
  mutation sendOtpEmail($otpType: OtpType!, $otpRef: String!) {
    sendOtpEmail(
      otpType: $otpType
      otpRef: $otpRef
    ){
      result
      msg
    }
  }
`
